export type MenuItem = {
  name: string;
  description?: string;
};

export type MenuCategory = {
  title: string;
  items: MenuItem[];
  image?: string;
};

export const menuData: MenuCategory[] = [
  {
    title: "Cocktails",
    image: "/images/menu-cocktails.webp",
    items: [
      { name: "Cocktail des Monats", description: "Barkeeper's Choice" },
      { name: "Whisky / Amaretto Sour", description: "Whisky/Amaretto, Zitrone, Zucker, Eiweiß" },
      { name: "Hibiscus Sour", description: "Erdbeer, Grapefruit, Zitrone, Zucker, Eiweiß" },
      { name: "Old Fashioned", description: "Whisky, Zucker, Angostura" },
      { name: "Negroni", description: "Gin, Campari, Roter Vermouth" },
      { name: "Gin Fizz", description: "Gin, Zitrone, Zucker, Soda, Eiweiß" },
      { name: "Cosmopolitan", description: "Vodka, Triple Sec, Cranberry, Limette" },
      { name: "Espresso Martini", description: "Vodka, Espresso, Kaffeelikör, Zucker" },
      { name: "Cuba Libre", description: "Rum, Limette, Cola" },
      { name: "Mojito / Mojito Erdbeer", description: "Rum, Minze, Limette, Zucker, Soda" },
      { name: "Caipirinha / Caipirinha Melon", description: "Cachaca, Limette, Rohrzucker" },
      { name: "Classic Margarita", description: "Tequila, Triple Sec, Limette, Zucker" },
      { name: "Frozen Margarita", description: "Erdbeere / Mango" },
      { name: "Moscow / London Mule", description: "Vodka/Gin, Limette, Angostura, Ginger Beer" },
      { name: "Pina Colada", description: "Rum, Ananas, Kokos" },
      { name: "Sex on the Beach", description: "Vodka, Pfirsichlikör, Cranberry, Pfirsich, Grenadine" },
      { name: "Tequila Sunrise", description: "Tequila, Orange, Grenadine" },
      { name: "Long Island Iced Tea", description: "Barkeeper's Choice" },
    ],
  },
  {
    title: "Alkoholfreie Cocktails",
    items: [
      { name: "Erdbeer Minze Limonade", description: "Erdbeer, Minze, Zitronensaft, Soda" },
      { name: "Ipanema", description: "Ginger Ale, Limette, Rohrzucker" },
      { name: "Refresher", description: "Orange, Maracuja, Ananas, Zucker, Grenadine" },
      { name: "Shirley Temple", description: "Ginger Ale, Kirsche, Zitrone" },
      { name: "El Nino", description: "Cranberry, Lime, Ginger Ale, Zitrone" },
      { name: "Hibiscus Bloom", description: "Gin 0,0%, Granatapfel, Zitrone, Zucker, Eiweiß" },
    ],
  },
  {
    title: "Secco Cocktails",
    items: [
      { name: "Aperol Spritz" },
      { name: "Aperol Maracuja Spritz" },
      { name: "Limoncello Spritz" },
      { name: "Hugo" },
      { name: "Sundowner", description: "auch alkoholfrei" },
      { name: "Sarti Spritz" },
      { name: "Lillet Wildberry" },
    ],
  },
  {
    title: "Champagner",
    image: "/images/menu-secco.webp",
    items: [
      { name: "Secco Verde", description: "Glas" },
      { name: "Prosecco Ca' Bolani", description: "Glas / 0.75l" },
      { name: "Chandon Spritz", description: "0.75l / 1.5l" },
      { name: "Chandon Brut", description: "0.75l" },
      { name: "Moët Chandon Brut", description: "Imperial – 0.75l / 1.5l" },
      { name: "Moët Chandon Rosé", description: "Imperial – 0.75l / 1.5l" },
      { name: "Moët Chandon Ice", description: "0.75l" },
      { name: "Dom Pérignon Luminous", description: "0.75l" },
      { name: "Ruinart Brut", description: "1.5l" },
      { name: "Ruinart Rosé", description: "1.5l" },
    ],
  },
  {
    title: "Longdrinks",
    image: "/images/menu-longdrinks.webp",
    items: [
      { name: "Cîroc Vodka-Soda", description: "Peach / Berry" },
      { name: "Smirnoff Vodka", description: "Longdrinks" },
      { name: "Tequila", description: "Longdrinks" },
      { name: "Bulleit Bourbon", description: "Cola / Ginger Ale" },
      { name: "Captain Morgan White Rum", description: "Cola" },
      { name: "Captain Morgan Spiced Rum", description: "Cola / 7 UP" },
      { name: "Johnnie Walker Black", description: "Cola / Ginger Ale" },
      { name: "Jameson", description: "Cola / Ginger Ale" },
      { name: "Jack Daniel's", description: "Cola" },
      { name: "Hennessy", description: "Cola" },
      { name: "Batida", description: "Kirsche" },
      { name: "Campari", description: "Orange / Soda" },
      { name: "Amaretto", description: "Kirsche" },
      { name: "Malibu", description: "Multivitamin / Kirsche / Orange" },
      { name: "Lychee", description: "7 UP" },
    ],
  },
  {
    title: "Gin",
    items: [
      { name: "Tanqueray", description: "Tonic (versch. Sorten)" },
      { name: "Tanqueray 0,0%", description: "Tonic" },
      { name: "Hendrick's", description: "Tonic" },
      { name: "Monkey 47", description: "Tonic" },
      { name: "Gin Mare", description: "Tonic" },
      { name: "Gin des Monats", description: "Tonic" },
    ],
  },
  {
    title: "Tequila",
    items: [
      { name: "Don Julio Blanco / Reposado" },
      { name: "Don Julio 1942" },
      { name: "Sierra Blanco" },
      { name: "Sierra Reposado" },
      { name: "Patron Silver" },
      { name: "Casamigos Blanco / Reposado" },
      { name: "Tequila Rose" },
    ],
  },
  {
    title: "Vodka",
    items: [
      { name: "Smirnoff Vodka" },
      { name: "Cîroc Ultra-Premium Vodka" },
    ],
  },
  {
    title: "Rum / Whisky / Cognac",
    items: [
      { name: "Ron Zacapa 23" },
      { name: "Ron Zacapa Royal" },
      { name: "Bulleit" },
      { name: "Jack Daniel's" },
      { name: "Gentleman Jack" },
      { name: "Woodford Reserve" },
      { name: "Jameson" },
      { name: "Lagavulin 16 Years" },
      { name: "Talisker 10 Years" },
      { name: "Laphroaig 10 Years" },
      { name: "Dalwhinnie 15 Years" },
      { name: "Bunnahabhain" },
      { name: "Glenkinchie 12 Years" },
      { name: "Oban 14 Years Old" },
      { name: "Johnnie Walker Black / Red" },
      { name: "Johnnie Walker Blue" },
      { name: "Hennessy V.S." },
      { name: "Hennessy XO" },
    ],
  },
  {
    title: "Shots / Liquor",
    items: [
      { name: "Berliner Luft" },
      { name: "Nuss-Nougat" },
      { name: "Erdbeerlimes" },
      { name: "Sourz Apple" },
      { name: "Sambuca" },
      { name: "Jägermeister" },
      { name: "Vodka Waldmeister" },
      { name: "Sierra Tropical" },
      { name: "Ramazzotti" },
      { name: "Baileys" },
    ],
  },
  {
    title: "Biere",
    items: [
      { name: "Radeberger Pilsner", description: "0.3l" },
      { name: "Jever Fun", description: "0.33l – Alkoholfrei" },
      { name: "Oberdorfer Helles", description: "0.3l" },
      { name: "Bübble Weizen", description: "0.5l" },
      { name: "Corona", description: "0.33l" },
    ],
  },
  {
    title: "Softdrinks",
    items: [
      { name: "Pepsi", description: "0.33l" },
      { name: "Pepsi Max", description: "0.33l" },
      { name: "Mirinda / 7 UP" },
      { name: "Wasser" },
      { name: "Stilles Wasser" },
      { name: "Karaffe Wasser", description: "1.0l" },
      { name: "Bitter Lemon", description: "0.33l" },
      { name: "Tonic Water", description: "0.33l" },
      { name: "Ginger Ale" },
      { name: "28 Black Energy" },
    ],
  },
  {
    title: "Säfte",
    items: [
      { name: "Apfel, Orange, Ananas" },
      { name: "Kirsch, Maracuja" },
      { name: "Cranberry, Multivitamin" },
      { name: "Johannisbeere, Pfirsich" },
      { name: "Saftschorlen" },
    ],
  },
  {
    title: "Weine",
    items: [
      { name: "Wein des Monats" },
      { name: "Riesling", description: "trocken" },
      { name: "Grauburgunder", description: "trocken" },
      { name: "Sauvignon Blanc", description: "trocken" },
      { name: "Bacchus", description: "lieblich" },
      { name: "Roséwein" },
      { name: "Rotwein" },
      { name: "Rieslingschorle", description: "süß / sauer" },
      { name: "Roséschorle", description: "süß / sauer" },
    ],
  },
  {
    title: "Flaschenpreise",
    image: "/images/menu-flaschen.webp",
    items: [
      { name: "Smirnoff Vodka", description: "0.7l – +1 Liter Filler oder 4 Dosen 28 Black" },
      { name: "Cîroc Ultra-Premium Vodka", description: "0.7l / 1.75l – +2 Liter Filler oder 8 Dosen 28 Black" },
      { name: "Belvedere", description: "0.7l" },
      { name: "Tanqueray Gin", description: "0.7l – +1 Liter Filler" },
      { name: "Jack Daniel's", description: "0.7l" },
      { name: "Zusätzlich 1 Liter Filler" },
    ],
  },
];
